import { PosMode } from '@/features/pos/types'
import { FC, ReactNode, createContext, use, useCallback, useMemo, useState } from 'react'

const Context = createContext<PosMode>('pos')

interface ActionsContextValue {
    setPos: () => void
    setPhone: () => void
    toggle: () => void
}

const ActionsContext = createContext<ActionsContextValue>({
    setPos: () => {},
    setPhone: () => {},
    toggle: () => {},
})

interface PosModeProviderProps {
    children: ReactNode
}

const PosModeProvider: FC<PosModeProviderProps> = ({ children }) => {
    const [mode, setMode] = useState<PosMode>('pos')

    const setPos = useCallback(() => setMode('pos'), [])

    const setPhone = useCallback(() => setMode('phone'), [])

    const toggle = useCallback(() => setMode((mode) => (mode === 'pos' ? 'phone' : 'pos')), [])

    const actions = useMemo(() => ({ setPos, setPhone, toggle }), [setPos, setPhone, toggle])

    return (
        <Context.Provider value={mode}>
            <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>
        </Context.Provider>
    )
}

export default PosModeProvider

export const usePosMode = () => use(Context)

export const usePosModeActions = () => use(ActionsContext)
